module.exports = __webpack_public_path__ + "img/chancerain.8bdf47fe.png";